<template>
  <div class="year-main-content">
    <div class="year-top-image" v-bind:style="{ backgroundImage: 'url(' + require('@/assets/' + topImage) + ')' }">
    <div class="year-overlay"><span>2014</span></div>
    </div>
    <div class="view-wrap yr2014">


<FullYearStats fullGames='16' fullCompletions='456' fullAttempts='659' fullYards='4,952' fullPct='69.2' fullTDs='33' fullINTs='17' fullYPG='309.5' fullRating='97.0'></FullYearStats>

  <div class="year-summary-wrapper">
    <div class="triangle-top-left"></div>
    <div class="triangle-bottom-right"></div>
    <div class="year-summary">
    
      
      <div class="year-summary-text-flex">

            <h1 class="content-headline">Another Pro Bowl season</h1>

      <div class="copy-paragraph">

      In 2014, Drew Brees tied for the NFL lead in passing yardage and led the league in completions, completing 456-of-659 passes (69.2%) for 4,952 yards. Brees would add 33 touchdown passes.
      <br/><br/>

      Drew would once again make the NFC's Pro Bowl squad, his eighth as a Saint (franchise record) and ninth overall.
      <br/><br/>

      Brees and the offense put up another strong season, but it wasn’t enough to overcome struggles by the defense. The Saints finished 7-9, losing five games by seven points or less.

      </div>

      <div class="copy-paragraph">
      <img :src="require('@/assets/brees-2014-img-in-copy.jpg')" style="width:100%;" alt="Drew Brees during pregame signing one of his jerseys for a military member">
      </div>


<div class="awards-wrapper">
        <div class="awards-headline">2014 Awards</div>
        <ul>
          <li><img :src="require('@/assets/pro-bowl.png')" alt="Pro Bowl Logo"> 2014 Pro Bowl</li>     
          
        </ul>
        <div class="awards-legend">
<b>AP</b> - Associated Press, <b>CN</b> - College & Pro Football Weekly, <b>FD</b> -Football Digest, <b>FN</b> -Football News, <b>FW</b> - Professional Football Writers of America, <b>NE</b> - Newspaper Enterprise Association, <b>NY</b> - New York Daily News, <b>PFWA</b> - Pro Football Writers of America, <b>PW</b> - Pro Football Weekly(1992-2012,choices combined with Pro Football Writers of America), <b>SI</b> - Sports Illustrated, <b>SN</b> - Sporting News, <b>UP</b> - United Press International, <b>UW</b> - USA Today/Sports Weekly
        </div>
      </div> 

      </div> <!--end text-flex-->
    </div>
  </div>


 <div class="bubble-chart-wrapper chart-light">
      <h2 class="chart-headline">2014 Top Rated Passers</h2>
      <BubbleChart :chart-data="dataBubble1" :options="dataOptions3" style="height:400px;"></BubbleChart>
</div>

<div class="touchdowns-header-wrapper">
  <h1><img src="https://nolaprodigital.com/saints/brees500/images/referee-icon-white.png" alt="Drew Brees 2014 Touchdown Tally"> 2014 TOUCHDOWN TALLY</h1>
</div>






</div>


<TDsByYear :tds="this.tds"></TDsByYear>



<flickity ref="flickity" :options="flickityOptions">
  <div class="carousel-cell"><img :src="require('@/assets/' + image1)" alt="Drew Brees in 2014 - Slide1"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image2)" alt="Drew Brees in 2014 - Slide2"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image3)" alt="Drew Brees in 2014 - Slide3"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image4)" alt="Drew Brees in 2014 - Slide4"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image5)" alt="Drew Brees in 2014 - Slide5"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image6)" alt="Drew Brees in 2014 - Slide6"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image7)" alt="Drew Brees in 2014 - Slide7"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image8)" alt="Drew Brees in 2014 - Slide8"></div>
</flickity>


<div class="year-pagination-wrapper">
  <div class="year-pagination-section year-pagination-prev"><router-link to="/year/2013">«2013</router-link></div>
  <div class="year-pagination-section year-pagination-current">2014</div>
  <div class="year-pagination-section year-pagination-next"><router-link to="/year/2015">2015»</router-link></div>
</div>



    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import StatsFlex from '@/components/StatsFlex.vue'
import Flickity from 'vue-flickity';
import VideoBtn from '@/components/VideoBtn.vue';
import FullYearStats from '@/components/FullYearStats.vue';
import TDsByYear from '@/components/TDsByYear.vue';
import BubbleChart from '@/components/BubbleChart.vue';

import axios from 'axios';

export default {
  name: 'yr2014',
  components: {
    Flickity,
    StatsFlex,
    VideoBtn,
    FullYearStats,
    TDsByYear,
    BubbleChart
  },
  metaInfo: {
    title: 'Drew Brees Stats and Touchdowns from his 2014 season',
    htmlAttrs: {
      lang: 'en'
    }
  },
  data() {
    return {
      tds: {},
      loading: false,
      games: [],
      topImage: "brees-2014-top.jpg",
      image1: "brees-2014-slide-1.jpg",
      image2: "brees-2014-slide-2.jpg",
      image3: "brees-2014-slide-3.jpg",
      image4: "brees-2014-slide-4.jpg",
      image5: "brees-2014-slide-5.jpg",
      image6: "brees-2014-slide-6.jpg",
      image7: "brees-2014-slide-7.jpg",
      image8: "brees-2014-slide-8.jpg",

      flickityOptions: {
            initialIndex: 0,
            prevNextButtons: false,
            pageDots: false,
            resize: true,
            wrapAround: true,
            autoPlay: true

            // any options from Flickity can be used
            }

          } 
        },
  methods: {
    async getTDs() {
      const self = this;
      const response = await axios.get(
        "../../static/td-data.json"
      );
      this.tds = response.data.y2014;
      console.log(this.tds)
    },
    next() {
      this.$refs.flickity.next();
    },

    previous() {
      this.$refs.flickity.previous();
    },
    resize() {
      this.$refs.flickity.resize();
    }
  },

  mounted: function() {
    this.getTDs();

    setTimeout(() => {
    this.$refs.flickity.resize();
    }, 2000)

  },

created() {

      

       this.dataBubble1 = {
      "datasets": [
      {
        "label": "Drew Brees",
        "backgroundColor": "#101820",
        "borderColor": "#D3BC8D",
        "fill": false,
        "pointBackgroundColor": '#D3BC8D',
        "pointColor": "#D3BC8D",
        
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#D3BC8D",
        data: [
                {
                  x: 69.2,
                  y: 4952,
                  r: 33/1.5
                }
              ]
      },
      {
        "label": "Tom Brady",
        "backgroundColor": "#002244",
        "borderColor": "#C60C30",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 64.1,
                  y: 4109,
                  r: 33/1.5
                }
              ]
      },
      {
        "label": "Peyton Manning",
        "backgroundColor": "#FB4F14",
        "borderColor": "#024",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 66.2,
                  y: 4727,
                  r: 39/1.5
                }
              ]
      },
      {
        "label": "Aaron Rodgers",
        "backgroundColor": "#203731",
        "borderColor": "#FFB612",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 65.6,
                  y: 4381,
                  r: 38/1.5
                }
              ]
      },
       {
        "label": "Tony Romo",
        "backgroundColor": "#041E42",
        "borderColor": "#869397",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 69.9,
                  y: 3705,
                  r: 34/1.5
                }
              ]
      }
      ]
    },
    this.dataOptions3 = {
        "responsive": true,
        "maintainAspectRatio": false,
        title: {
            display: true,
            text: '(Bubble size is Touchdowns)'
        },
        "layout": {
          padding: {
                left: 10,
                right: 10,
                top: 0,
                bottom: 0
          },
        },
        "legend": {
          "position" : "bottom",
            "maxSize" : {
                "height" : 400
            },
            "labels": {
                "fontColor": "black",
                "fontSize": 14,
                "usePointStyle" : true
            }
        },
        tooltips: {
          "mode": "point",
          callbacks: {
              label: function(tooltipItem, data) {
                 var rLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].r;
                  var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
                  return datasetLabel + ' : ' + tooltipItem.yLabel.toLocaleString() + ' Yards, ' + tooltipItem.xLabel.toLocaleString() + ' Completion %, ' + rLabel*1.5 + ' TDs';
              }
          }
        },
        "scales": {
          "yAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Yards'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
                },
            "ticks": {
              "fontColor": 'black',
              callback: function(value, index, values) {
                        return value.toLocaleString();
                    },
            },
          }],
          "xAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Completion Percentage'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
            },
            "ticks": {
              
              "fontColor": 'black'
            },
          }]
        }
    }

    }
}
</script>

<style>

.year-top-image > img {
  width:100%;
}


@media (max-width:767px;) {
  .year-main-content {
  margin-top:35px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/yr2014.vue